import React from "react";

import Checkbox from '../components/checkbox';
import Dump from "../components/dump.tsx";

export default function Filter(props) {

	let values = (typeof props.values == 'undefined') ? [] : props.values;

	function handleChange(e, value) {
		if (typeof props.onCheckboxChange == 'function') {
			props.onCheckboxChange(e, props.property, value);
		}
	}

	let inputs = [];

	Object.keys(values).forEach((key) => {
		let value = values[key];
		let name = key;

		inputs.push((<span key={props.property + name}>
			<div>
				<label>
					<Checkbox
						type="checkbox"
						checked={props.selectedFilters?.includes(value)}
						onChange={(e) => handleChange(e, value)}
					/>
					&nbsp;{name}
				</label>
			</div>
			{/*<Dump {...props.selectedFilters}/>*/}
			{/*<Dump value={value}/>*/}
			{/*<Dump value={props.selectedFilters?.includes(value)}/>*/}
		</span>));
	});

	return (<>
		<div className="filter">
			<p className="mb-2">{props.name}</p>
			{inputs}
		</div>
	</>);
}
